module.exports = __webpack_public_path__ + "img/logo.2d6c76b3.png";